<template>
  <div class="export-container" v-if="initializing">
    <p>Filtered by:</p>
    <p>{{ clientNameExport }}</p>
    <p>{{ assetsNumber }}</p>
    <p>{{ categoriesNumber }}</p>
    <p>{{ statusNumber }}</p>
    <p v-if="clientNumber > 0">{{ productNameExport }}</p>
    <p v-if="searchTerm">Search Term: {{ searchTerm }}</p>
    <div class="export-actions">
      <button class="mds-button" type="button" @click="closeModal">
        Cancel
      </button>
      <mds-button variation="primary" @click="startExporting" class="export-button">
        Export
      </mds-button>
    </div>
  </div>
  <div class="export-container" v-else-if="exporting">
    <loader-spinner v-if="exporting" />
    <p class="export-process-text">Loading</p>
    <button class="mds-button" type="button" @click="abortExport">
      Cancel
    </button>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import FileSaver from 'file-saver';
import b64toBlob from 'b64-to-blob';
import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only';
import LoaderSpinner from '@/components/atoms/LoadingSpinner';
import { exportFundsData } from '@/services/Export';

export default {
  name: 'export-data',
  components: {
    LoaderSpinner,
  },
  methods: {
    ...mapActions({
      closeModal: 'closeModal',
    }),
    startExporting() {
      this.exporting = true;
      this.initializing = false;

      exportFundsData({
        clientNumber: this.clientNumber,
        fiduciaryNumber: this.fiduciaryNumber,
        queryOptions: this.queryOptions,
      }).then((response) => {
        const { data } = response;
        const blob = b64toBlob(data.file, data.type);
        FileSaver.saveAs(blob, this.fileName);
        this.closeModal();
        this.$store.dispatch('openNotification', {
          message: `${this.fileName} is ready`,
        });
      }).catch((error) => {
        const httpStatus = (error?.response.status) ? (error?.response.status) : error?.status;
        if (httpStatus === 401) {
          this.$router.push('/Login');
        }
      });
    },
    abortExport() {
      this.controller.abort();
      this.closeModal();
    },
  },
  computed: {
    ...mapState({
      clientName: (state) => state.grid.client.name,
      clientNumber: (state) => state.grid.client.selected,
      productName: (state) => state.grid.product.name,
      productNumber: (state) => state.grid.product.selected,
      searchTerm: (state) => state.grid.searchTerm,
      fiduciaryNumber: (state) => state.user.fiduciary.id,
      fiduciaryName: (state) => state.user.fiduciary.name,
    }),
    clientNameExport() {
      if (this.clientNumber === 0) {
        return 'All Clients';
      }
      return `Client: ${this.clientName}`;
    },
    productNameExport() {
      return `Product: ${this.productName}`;
    },
    assetsNumber() {
      let output = '';
      if (this.data.assets.length > 0) {
        output = 'Asset Classes: ';
        output += this.data.assets.join(', ');
      } else {
        output = 'All Asset Classes';
      }
      return output;
    },
    categoriesNumber() {
      let output = '';
      if (this.data.categories.length > 0) {
        output = 'Categories: ';
        output += this.data.categories.join(', ');
      } else {
        output = 'All Categories';
      }
      return output;
    },
    statusNumber() {
      let output = '';
      if (this.data.status.length > 0) {
        output = 'Statuses: ';
        output += this.data.status.join(', ');
      } else {
        output = 'All Statuses';
      }
      return output;
    },
    queryOptions() {
      const parameters = [];
      if (this.data.status.length > 0) {
        const escapedParameters = this.data.status.map(
          (item) => encodeURIComponent(item.toLowerCase()),
        );
        parameters.push(`status=${escapedParameters}`);
      }
      if (this.data.categories.length > 0) {
        const escapedParameters = this.data.categories.map((item) => encodeURIComponent(item));
        parameters.push(`category=${escapedParameters}`);
      }
      if (this.data.assets.length > 0) {
        const escapedParameters = this.data.assets.map((item) => encodeURIComponent(item));
        parameters.push(`broadassetclass=${escapedParameters}`);
      }
      if (this.clientNumber > 0 && this.productNumber > 0) {
        parameters.push(`product=${this.productNumber}`);
      }
      if (this.searchTerm) {
        parameters.push(`search=${encodeURIComponent(this.searchTerm.toLowerCase())}`);
      }
      return parameters.join('&');
    },
    fileName() {
      let name = this.fiduciaryName;
      if (this.clientNumber === 0) {
        name += ' All Clients';
      } else {
        name += ` ${this.clientName}`;
      }
      name += ' Universe ';
      const d = new Date();
      name
        += String(d.getFullYear())
        + String(d.getMonth() + 1)
        + String(d.getDate())
        + String(d.getHours())
        + String(d.getMinutes())
        + String(`${d.getSeconds()}.xlsx`);
      return name;
    },
  },
  data() {
    return {
      initializing: true,
      exporting: false,
      exported: false,
      controller: new AbortController(),
    };
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>
<style lang="scss">
.export-container {
  @include mds-body-text-m();
  .export-process-text {
    text-align: center;
    @include mds-body-text-l();
  }
  .export-actions {
    text-align: right;
    @include fc-buttons-list();
  }
}
</style>
